import { ScheduledJob } from './scheduled-job.model';

export class CreateScheduledJobCommand {
    entity_id: number;
    type: string;
    execution_timestamp: number;
    context: any;

    constructor(scheduledJob: ScheduledJob, timestamp?: number, context?: any) {
        this.entity_id = parseInt(scheduledJob.entityId);
        this.type = scheduledJob.type;
        this.execution_timestamp = timestamp;
        this.context = context;
    }
}
